// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__vwFrl","gfeWrapper":"CalendarEvent_gfeWrapper__3TmIl"};